import { render, staticRenderFns } from "./TabRedemption.vue?vue&type=template&id=2ceaad9a"
import script from "./TabRedemption.vue?vue&type=script&lang=js"
export * from "./TabRedemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports